export default __webpack_public_path__ + "static/media/marquee4.13fd8478.png";